import useStyles from './styles';
import { TextField, MenuItem } from '@mui/material';
//=====================

const DropDownComponent = ({ value, label, onChange, options, editable }) => {
  const classes = useStyles();

  return (
    <TextField
      select
      id="outlined-select"
      style={{ width: '100%', margin: '1rem 0' }}
      value={value}
      label={label}
      onChange={(e) => onChange(e.target.value)}
      disabled={editable === false}
      variant="outlined"
    >
      {options.map((option) => (
        <MenuItem key={option} value={option}>
          {option}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default DropDownComponent;